module.exports = __webpack_public_path__ + "static/media/wallet_icon_dark.9ba20de6.svg";